import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { debounce } from 'lodash';
import { useHistory } from 'react-router-dom';
import AlertModal from 'web/components/AlertModal';
import ProfilePicture from 'web/assets/images/userPicDummy.jpeg'
import { searchGroupApi } from 'redux/actions/myNetwork';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import './typeahead.scss';

const SearchTypeGroup = (props) => {
  const { placeholder, asyncSearch, toggle, defaulTitle, pageName, transparent, focusOnShow, searchDropDown, callBack } = props
  const ref = useRef();
  let history = useHistory();
  const [pageNumber, setPageNumber] = useState(40);

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  let defaultTxt = defaulTitle;
  const [defaultState, setDefaultState] = useState(defaultTxt);

  useEffect(() => {
    if (focusOnShow) {
      ref.current.focus();
    }
    if (defaultTxt === "" && ref.current) {
      ref.current.clear()
    }
    setDefaultState(defaultTxt)
  }, [defaultTxt]);

  const debouncedSearch = useCallback(debounce(async (query, props) => {
    await handleSearch(query, props);
  }, 500), []);

  const handleSearch = async (query, pageProps) => {
    callBack(query)
    let propValue = pageProps || props
    if (query.length >= 4) {
      searchGroupApiCall(query, 1, propValue)
    }
  };

  const searchGroupApiCall = async (query, page, props) => {
    const { searchDropDown, callBack } = props
    let postData = {
      size: 100,
      number: (page - 1) ?? 0,
      sort: "DESC",
      searchBy: query || "",
    };
    let url = (searchDropDown === 'GROUP') ? 'rfp/v2/search/community_group' : 'user/v2/search/community_members'

    let response = await dispatch(searchGroupApi(url, postData, token));

    if (response.success) {
      if (response.data?.totalElements === 0) {
        callBack(query);
      }

      if (response.data?.totalElements > 0) {
        const options = response.data?.communitySearch?.map((i) => ({
          id: i.userId || i.groupId,
          networkName: i.groupName ? i.groupName : i.userName,
          userFullName: i.userName,
          description: i.description,
          city: i.city,
          state: i.state,
          profileImage: i.profileImage,
          locationName: i.locationName
        }));
        setOptions(options);
      }
    } else {
      if (response.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in')
        window.location.reload(false);
      }
    }
  }

  const handlePagination = (e, shownResults) => {
    setPageNumber(pageNumber + 1)
    searchGroupApiCall(defaultState, pageNumber + 1, props)
  }

  return (
    asyncSearch && (
      <>
        <div className={`type-ahead-search-input ${transparent ? "search-input-transparent" : ""}`}>
          <AsyncTypeahead
            ref={ref}
            multiple={false}
            id={Math.random().toString()}
            labelKey={"networkName"}
            filterBy={["networkName", "description", "city", "state", "companyName", "locationName", "userFullName"]}
            isLoading={false}
            maxResults={40}
            minLength={2}
            onSearch={(query) => handleSearch(query)}
            options={options}
            onPaginate={handlePagination}
            paginate
            paginationText={"Show More..."}
            placeholder={placeholder}
            defaultInputValue={""}
            onInputChange={(text) => {
              setDefaultState(text);
              // handleSearch(text, 1);
              debouncedSearch(text, props)
              // callBack(text);
            }}
            onKeyDown={(event) => {
            }}
            onChange={(event) => {
              if (event.length !== 0 && event[0] && event[0].networkName) {
                // handleSearch(event[0].networkName.toString(), 1);
                debouncedSearch(event[0].networkName.toString(), props);
                setDefaultState(event[0].networkName);
                // callBack(event[0].networkName);
              }
              _.isFunction(toggle) && toggle();
            }}
            renderMenuItemChildren={(option) => (
              <div key={option.id} style={{ display: 'flex' }} onClick={() => {
              }}>
                <img
                  alt={option.networkName}
                  src={option.profileImage ? (process.env.REACT_APP_API_URL + "/user/image/" + option.profileImage) : ProfilePicture}
                  style={{
                    height: '30px',
                    marginRight: '10px',
                    width: '30px',
                    'border-radius': '50%'
                  }}
                />
                <div>
                  <span style={{ display: 'block' }}>{option.networkName ? option.networkName : option.userFullName}</span>
                  <span style={{ display: 'block' }}><small>{option.locationName}</small></span>
                  {option.city && option.state && <span style={{ display: 'block' }}><small>{option.city.trim()}&nbsp; {option.state}</small></span>}
                  <span style={{ display: 'block' }}><small>{searchDropDown === 'GROUP' ? "Group" : "Member"}</small></span>
                </div>
              </div>
            )}
            useCache={false}
          />

        </div>
        <div
          className="seacrh-icon"
          onClick={(event) => {
            setDefaultState(defaultState);
            callBack(defaultState);
          }}
        >
          <button>Search</button>
        </div>
        {pageName !== "Landing" && (
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title=""
            content=''
            link=''
          />
        )}
      </>
    )
  );
};

SearchTypeGroup.propTypes = {
  placeholder: PropTypes.string,
  minLength: PropTypes.number,
  asyncSearch: PropTypes.bool,
  searchUrl: PropTypes.string,
  focusOnShow: PropTypes.bool,
  background: PropTypes.string,
  color: PropTypes.string,
};

SearchTypeGroup.defaultProps = {
  placeholder: '',
  minLength: 1,
  asyncSearch: true,
  /**
   * @todo : SearchUrl and filterBy should be empty, this needs to be refactored after search api integration
   */
  searchUrl: 'https://api.github.com/search/users',
  filterBy: 'login',
  transparent: false,
  focusOnShow: true,
};

export default SearchTypeGroup;
